import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { Colors } from '../config/constants'

@Component({
  standalone: false,
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() label: string
  @Input() icon: string
  @Input() loading = false
  @HostBinding('class.disabled')
  @Input()
  disabled = false
  @Input() @HostBinding('class.secondary') secondary = false

  @Output() onClick = new EventEmitter<any>()

  colorLoading = Colors.colorWhite

  @HostListener('click') click() {
    if (!this.disabled || (!this.disabled && !this.loading)) {
      this.onClick.emit()
    }
  }

  constructor() {}

  ngOnInit() {}
}
